import { render, staticRenderFns } from "./TenderSummary.vue?vue&type=template&id=d7a5623e&"
import script from "./TenderSummary.vue?vue&type=script&lang=js&"
export * from "./TenderSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports